import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';
import FormDatosEmail from './FormDatosEmail';
import { withApollo, graphql, compose } from 'react-apollo';

import enviarOficioPorEmail from '../../../../graphql/mutations/common/enviarOficioPorEmail.graphql';
import getOrganismos from '../../../../graphql/querys/organismos/getOrganismos.graphql';

@compose(
  graphql(getOrganismos, {
    name: 'getOrganismos',
  }),
  graphql(enviarOficioPorEmail, { name: 'enviarOficioPorEmail' })
)
class ModalMandarEmail extends Component {
  state = {
    enviandoEmail: false,
  };

  handleOk = datos => {
    this.setState({
      enviandoEmail: true,
    });
    this.props
      .enviarOficioPorEmail({
        variables: {
          _id: this.props.idOficio,
          emailDestino: datos.emailDestino + '@jusneuquen.gov.ar',
          cuerpo: datos.cuerpo,
        },
      })
      .then(res => {
        if (res && res.data.enviarOficioPorEmail) {
          notification.success({
            message: 'El email se ha enviado correctamente.',
          });
          this.setState({
            enviandoEmail: false,
          });

          this.props.ocultarModalMandarEmail();
        } else {
          this.setState({
            enviandoEmail: false,
          });
          notification.error({
            message: 'Error a la hora de enviar el email, intente nuevamente.',
          });
        }
      })
      .catch(err => {
        this.setState({
          enviandoEmail: false,
        });
        console.log('ERROR AL ENVIAR EL EMAIL: ', err);
        notification.error({
          message: 'Error a la hora de enviar el email, intente nuevamente.',
        });
      });
  };

  render() {
    let organismos = this.props.getOrganismos.getOrganismos;
    if (organismos && !organismos.length) {
      return null;
    }

    return (
      <div>
        <Modal
          title="Enviar Oficio por Email"
          visible={this.props.visibleModalMandarEmail}
          onCancel={this.props.ocultarModalMandarEmail}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormDatosEmail
            onSubmit={this.handleOk}
            organismos={organismos}
            enviandoEmail={this.state.enviandoEmail}
          />
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalMandarEmail);
